import { SelectionChangedEvent } from "ag-grid-community";
import { DirectDataInputEntity } from "domain/entity/DirectDataInput/DirectDataInputEntity";
import { INITIAL_DIRECT_DATA_INPUT_COL_DEF, INITIAL_DIRECT_DATA_INPUT_COL_DEF_OICT, transferRowData } from "presentation/constant/DirectDataInput/DirectDataInputColumnDefinition";
import { useDirectDataInputVM } from "presentation/hook/DirectDataInput/useDirectDataInputVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useDirectDataInputTracked } from "presentation/store/DirectDataInput/DirectDataInputProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";


const DirectDataInputTablePanel: React.FC = () => {
    const [directDataInputState] = useDirectDataInputTracked();
    const directDataInputVM = useDirectDataInputVM();
    const gridRef: any = useRef(null);
    const { directDataInputList } = directDataInputState
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate, operatingUnit } = anaInfoState;
    const messageBarVM = useMessageBarVM();
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(directDataInputState.isSearchLoading || (!directDataInputState.isSearchLoading &&
            directDataInputList && directDataInputList.length) ? false : true);

        if (gridRef.current?.gridRef.current && !directDataInputState.isSearchLoading &&
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.length > 0) {
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.forEach((node: any) => {
                node.setSelected(false);
            });
        }
    }, [directDataInputState.isSearchLoading, directDataInputList]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();

        directDataInputVM.updateSelectedRows(selectedRows);
    }, [directDataInputVM])


    const handleRowDoubleClick = useCallback((entity: DirectDataInputEntity) => {
        if (entity.status !== 'NEW') {
            messageBarVM.showError("Record Status is " + entity.status + ", cannot edit.");
            return;
        }
        allowUpdate && directDataInputVM.onRowDoubleClick(entity);
    }, [allowUpdate, directDataInputVM, messageBarVM])


    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='direct-data-input-table'
                isNewColumnSetting={true}
                columns={(operatingUnit === 'SAPT' || operatingUnit === 'KICT') ? INITIAL_DIRECT_DATA_INPUT_COL_DEF?.slice() : INITIAL_DIRECT_DATA_INPUT_COL_DEF_OICT?.slice()}
                data={transferRowData(directDataInputList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"multiple"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                onRowDoubleClick={(e: any, entity: DirectDataInputEntity) => handleRowDoubleClick(entity)}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
                showDefaultOverlayNoRowsTemplate={showOverlay}
            />
        );
    }, [directDataInputList, handleSelectionChange, handleRowDoubleClick, operatingUnit, showOverlay])

    return <>
        <TableWrapper>
            {memoTable}
        </TableWrapper>
    </>;
}

export default memo(DirectDataInputTablePanel);
